export default __webpack_public_path__ + "static/media/R7.f53d71c4.JPG";